<template>
  <div>
    <p class="linespace40"></p>

    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="model-title">Model Master</div>
          <div class="model-show-delete">
            <label for="show-del-flg">
              <input type="checkbox" id="show-del-flg" name="show-del-flg" placeholder="" v-model="show_del_flg" @change="showDelete">
              show deleted model
            </label>
          </div>
	</div>
      </div>
      <div class="row">
	<div class="col-12">
	  <div class="d-flex align-items-center justify-content-center">
	    <EasyDataTable
	      table-class-name="custom"
	      v-model:server-options="serverOptions"
	      :server-items-length="serverItemsLength"
	      :loading="loading"
	      :headers="headers"
	      :items="items"
	      :body-row-class-name="bodyRowClassNameFunction"
	      :rowsItems=[5,10,20]
	      :mustSort=true
	      @click-row="selectModel"
	      style="width: 100%"
	      border-cell
	      />
	  </div>
	</div>
      </div>
    </div>

    <div class="container mt-4 mb-4">
      <form>
	<div class="card">
	  <div class="card-header text-left text-bold">Model Info</div>
          <div class="card-body">

            <div class="form-group row">
              <label for="model-name" class="col-sm-2 col-form-label">Model Name</label>
              <div class="col-sm-10">
		<input type="text" class="form-control" id="model-name" name="model-name" style="width:98%;" placeholder="" v-model="model_name" @input="change" maxlength="30">
              </div>
            </div>

            <div class="form-group row">
	      <div class="col-sm-8">
          <div class="model-deleteflag">
            <label for="del-flg">
              <input type="checkbox" id="del-flg" name="del-flg" placeholder="true" v-model="update_del_flg" @change="change_delete_flg">
              Delete Flag(Turn on the check for unsupported models)
            </label>
          </div>
	      </div>
              <div class="offset-sm-2 col-sm-2 d-flex align-items-center justify-content-center pad-8-top">
		<button type="button" class="bluebtn2" @click="add" v-bind:disabled="disable_add">Add</button>
	      </div>
            </div>

            <div class="form-group row">
              <div class="offset-sm-10 col-sm-2 d-flex align-items-center justify-content-center pad-4">
		<button type="button" class="bluebtn2" @click="update" v-bind:disabled="disable_update">Update</button>
	      </div>
            </div>

            <div class="form-group row">
              <div class="offset-sm-10 col-sm-2 d-flex align-items-center justify-content-center pad-4">
		<button type="button" class="bluebtn2" @click="del" v-bind:disabled="disable_delete">Delete</button>
	      </div>
            </div>

	  </div>
	</div>
      </form>
    </div>
    
    <p class="linespace20"></p>
    <div class="container">
      <div class="text-right">
	<router-link to="./FirmwareUpdate.html">
	  <div class="greenbtnM">Close</div>
	</router-link>
      </div>
    </div>
    <p class="linespace20"></p>
  </div>

  <ConfirmDialog />
  <ErrorDialog />
</template>

<script setup>
import { ref, computed, watch } from 'vue';
import { checkMaintenance, getModelList, addModel, updateModel, deleteModel } from '../server';
import { error } from './ErrorDialog.vue';
import { confirmRealDel } from './ConfirmDialog.vue';

checkMaintenance();

const headers = [
    {
	text: 'Model ID',
	value: 'model_id',
	sortable: true
    },
    {
	text: 'Model Name',
	value: 'model_name',
	sortable: true
    }
];

const items = ref([]);

const loading = ref(false);
const serverItemsLength = ref(0);
const serverOptions = ref({
    page: 1,
    rowsPerPage: 10,
    sortBy: 'model_id',
    sortType: 'desc'
});
const show_del_flg = ref(false);

const loadModelFromServer = async() => {
    loading.value = true;
    try {
	let res = await getModelList(show_del_flg.value,serverOptions.value);
	items.value = res.serverCurrentPageItems;
	serverItemsLength.value = res.serverTotalItemsLength;
    }
    catch(e) {
	console.log(e)
    }
    finally {
	loading.value = false;
    }
};

loadModelFromServer();

watch(serverOptions, (value) => { loadModelFromServer(); }, { deep: true });

const selected = ref(null);
const selected_item = ref(null);
const model_name = ref('');

const update_del_flg = ref(false);

const disable_add = ref(true);
const disable_update = ref(true);
const disable_delete = ref(true);

const selectModel = (item) => {
    selected.value = item.model_id;
    selected_item.value = item;
    model_name.value = item.model_name;

    disable_add.value = true;
    disable_update.value = false;
    disable_delete.value = false;
    update_del_flg.value = Boolean(Number(item.del_flg));
};

const change = () => {
    if (!disable_add.value) {
      return;
    }
    disable_add.value = false;
//    if(selected.value == null){
//      disable_update.value = true;
//    }
};

const change_delete_flg = () => {
    if (!disable_update.value || model_name.value === '') {
	return;
    }
    if(selected.value != null){
      disable_update.value = false;
    }
};
const add = async() => {
    if (model_name.value == '') {
	error('input model name');
	return;
    }
    let model = {
	model_name: model_name.value,
  del_flg: update_del_flg.value
    };
  
    try {
	let res = await addModel(model, serverOptions.value);
    }
    catch(e) {
	console.log(e)
    }
    await loadModelFromServer();
};

const update = async() => {
    if (model_name.value == '') {
	error('input product name');
	return;
    }
    let model = {
	model_id: selected_item.value.model_id,
  del_flg: Number(update_del_flg.value),
  model_name: model_name.value,
    };
  
    try {
      	let res = await updateModel(model);
    }
    catch(e) {
	console.log(e)
    }
    await loadModelFromServer();
};

const del = () => {
    confirmRealDel(realDel)
};

const realDel = async() => {
    let model = {
	model_id: selected_item.value.model_id,
    };
  
    try {
	let res = await deleteModel(model);
	disable_add.value = true;
	disable_update.value = true;
	disable_delete.value = true;

	selected.value = null;
	selected_item.value = null;
	model_name.value = '';
    }
    catch(e) {
	console.log(e)
    }
    await loadModelFromServer();
};

const bodyRowClassNameFunction = (item, index) => {
  let result = 'odd-row';
  if (item.model_id == selected.value) {
    result = 'select-row';
  }
  return result;
};

const showDelete = async() => {
  serverOptions.value.page=1;
  selected.value = null;
	selected_item.value = null;
	model_name.value = '';
  await loadModelFromServer();
};

</script>
    
<style>
.select-row {
  --easy-table-body-row-background-color: #6cbef5;
}
.odd-row {
  --easy-table-body-row-background-color: #ffffff;
}
.custom {
    --easy-table-header-background-color: #9df5bc;
}
</style>
